"use client";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";

import RecipeCarouselCard from "../UI/Cards/RecipeCarouselCard";
interface RecipeCardProps {
  item: any;
  list_name?: string;
  searchQuery?: string;
  isSearchPage?: boolean;
  index?: number;
  hasAddToFavRun?: any;
  setIsPanelOpen?: any;
}

export const RecipeCard = ({
  index = 0,
  item,
  list_name = "",
  searchQuery = "",
  isSearchPage = false,
  hasAddToFavRun = false,
  setIsPanelOpen,
}: RecipeCardProps) => {
  const { favourite } = useAppSelector((state) => state.RecipeToList);
  return (
    <RecipeCarouselCard
      index={index}
      item={{
        ...item,
        image: item.featuredImage,
        preparationTime: item?.cooking?.totalTime,
        id: item?.objectID,
      }}
      list_name={list_name}
      isSearchPage={isSearchPage}
      searchQuery={searchQuery}
      favouritesRecipes={favourite?.recipes}
      hasAddToFavRun={hasAddToFavRun}
      grid={true}
      setIsPanelOpen={setIsPanelOpen}
    />
  );
};
